/* global axios */

import ApiClient from './ApiClient';

class AgentAvailability extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  getSchedule(agentId) {
    return axios.get(`${this.url}/${agentId}/availability`);
  }

  updateSchedule(agentId, payload) {
    return axios.patch(`${this.url}/${agentId}/availability`, payload);
  }

  getAbsences(agentId) {
    return axios.get(`${this.url}/${agentId}/absences`);
  }

  createAbsence(agentId, payload) {
    return axios.post(`${this.url}/${agentId}/absences`, payload);
  }

  deleteAbsence(agentId, absenceId) {
    return axios.delete(`${this.url}/${agentId}/absences/${absenceId}`);
  }

  // agents whose availability the current user may manage: everyone for an
  // administrator, the members of their queues for a store manager
  getManagedAgents() {
    return axios.get(`${this.baseUrl()}/managed_agents`);
  }

  getTeamManagers(teamId) {
    return axios.get(`${this.baseUrl()}/teams/${teamId}/managers`);
  }

  addTeamManager(teamId, userId) {
    return axios.post(`${this.baseUrl()}/teams/${teamId}/managers`, {
      user_id: userId,
    });
  }

  removeTeamManager(teamId, userId) {
    return axios.delete(`${this.baseUrl()}/teams/${teamId}/managers/${userId}`);
  }
}

export default new AgentAvailability();
